import {each, reduce} from './lang/array';
import {Collection} from './structures/collection';

const
    events = (...names) => {
        const
            collections = (
                reduce(
                    names,
                    (collections, name) => {
                        collections[name] = new Collection();
                        return collections;
                    },
                    {})),
            additions = (
                reduce(
                    names,
                    (additions, name) => {
                        additions[name] = new Collection();
                        return additions;
                    },
                    {})),
            removals = (
                reduce(
                    names,
                    (removals, name) => {
                        removals[name] = new Collection();
                        return removals;
                    },
                    {}));

        return {
            count: (
                reduce(
                    names,
                    (counts, name) => {
                        const collection = collections[name];

                        counts[name] = () => collection.count;
                        return counts;
                    },
                    {})),
            publish: (
                reduce(
                    names,
                    (publishers, name) => {
                        const collection = collections[name];

                        publishers[name] = value => {
                            collection.each(fn => {
                                fn(value);
                            });
                        };
                        return publishers;
                    },
                    {})),
            subscribe: (
                reduce(
                    names,
                    (subscribers, name) => {
                        const
                            collection = collections[name],
                            addition = additions[name],
                            removal = removals[name];

                        subscribers[name] = (
                            fn => {
                                const edge = collection.add(fn);

                                addition.each(fn => {
                                    fn(collection.count);
                                });
                                return () => {
                                    edge.remove();
                                    removal.each(fn => {
                                        fn(collection.count);
                                    });
                                };
                            });
                        return subscribers;
                    },
                    {})),
            added: (
                reduce(
                    names,
                    (adders, name) => {
                        const addition = additions[name];

                        adders[name] = (
                            fn => {
                                const edge = addition.add(fn);

                                return () => {
                                    edge.remove();
                                };
                            });
                        return adders;
                    },
                    {})),
            removed: (
                reduce(
                    names,
                    (removers, name) => {
                        const removal = removals[name];

                        removers[name] = (
                            fn => {
                                const edge = removal.add(fn);

                                return () => {
                                    edge.remove();
                                };
                            });
                        return removers;
                    },
                    {}))
        };
    },

    registry = () => {
        let cancellers = [];

        return (...next) => {
            each(cancellers, cancel => {
                cancel();
            });
            cancellers = next;
        };
    };

export default events;
export {
    registry
};
